<template>
  <div class="loginArea d-flex flex-column">
    <div class="headerBanner">
      <img src="../../assets/logo/logoWhite.svg" width="" alt="" v-if="getPlatformInfo('id') == 3">
      <p v-else-if="getPlatformInfo('id')" class="mt-3" style="color: white;text-align: center">{{
          getPlatformTitle()
        }}</p>
    </div>
    <div class="loginContainer flex-grow-1">
      <SignInForm @afterSignIn="afterSignIn"/>
    </div>
    <div class="footerArea text-center py-2">
      © copyright 2022 {{ getDomainPlatform() }} All Rights Reserved
    </div>
  </div>
</template>
<script>
import SignInForm from "@/components/Auth/SignInForm";
import globalMixins from "@/mixins/globalMixins";

export default {
  name: 'SignInWindow',
  components: {SignInForm},
  mixins: [globalMixins],
  methods: {
    afterSignIn() {
      this.$emit('afterSignIn')
    }
  }
}
</script>

<style scoped>
@media (min-width: 200px ) and (max-width: 600px) {
  .loginBox {
    width: 90% !important;
    margin: 10px auto !important;
  }

  .loginArea {
    overflow: auto !important;
  }

  .headerBanner {
    height: 30px !important;
  }
}

.headerBanner {
  background: #3cbe8b;
  height: 55px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}

.headerBanner img {
  margin: 0px auto;
}

.loginArea {
  height: 100%;
  overflow: hidden;
}

.loginContainer {
  background: url("../../assets/image/webp/login/Login.jpg") no-repeat center;
  background-size: cover;
}

.footerArea {
  color: #6d6d6d;
  font-size: 12px;
  direction: ltr
}


</style>

